// console.log('Site:input');

export const keys = {
  BACKSPACE   : 8,
  TAB         : 9,
  ENTER       : 13,
  SHIFT       : 16,
  CTRL        : 17,
  ALT         : 18,
  ESCAPE      : 27,
  SPACE       : 32,
  PAGE_UP     : 33,
  PAGE_DOWN   : 34,
  END         : 35,
  HOME        : 36,
  ARROW_LEFT  : 37,
  ARROW_UP    : 38,
  ARROW_RIGHT : 39,
  ARROW_DOWN  : 40,
};
